import API from "../../../api";

export const getCertificate = data => {
  const { account_number, type, effective_date, process_date, amend_id } = data;
  return API.agent().get(
    `/accounts/${account_number}/certificate?type=${type}&effective_date=${effective_date}&process_date=${process_date}&amend_id=${amend_id}`,
    { responseType: "blob" }
  );
};
